/**
 * Route-level code splitting — deferred pages loaded on navigation only.
 * Core service paths remain eagerly imported in App.tsx.
 */
import { lazyPage } from "@/lib/lazyPage";

// ─── Home & misc ─────────────────────────────────────────────────────────────
export const Home = lazyPage(() => import("@/pages/Home"));
export const Broadcast = lazyPage(() => import("@/pages/Broadcast"));
export const StaffPreferencesPage = lazyPage(() => import("@/pages/StaffPreferencesPage"));
export const CleoChatPage = lazyPage(() => import("@/pages/CleoChatPage"));

// ─── Procurement & Inventory ─────────────────────────────────────────────────
export const ProcurementDashboardPage = lazyPage(() => import("@/pages/ProcurementDashboardPage"));
export const ProcurementMurhoDocumentsPage = lazyPage(() => import("@/pages/ProcurementMurhoDocumentsPage"));
export const ProcurementCorrespondenceInboxPage = lazyPage(
  () => import("@/pages/ProcurementCorrespondenceInboxPage"),
);
export const AdminProcurementCorrespondencePage = lazyPage(
  () => import("@/pages/AdminProcurementCorrespondencePage"),
);
export const AdminMassDoUploadPage = lazyPage(() => import("@/pages/AdminMassDoUploadPage"));
export const ProcurementPickListPage = lazyPage(() => import("@/pages/ProcurementPickListPage"));
/** Legacy Retail Handovers URLs — thin redirect shells into the unified workspace. */
export const ProcurementListPage = lazyPage(() => import("@/pages/ProcurementListPage"));
export const ProcurementDetailPage = lazyPage(() => import("@/pages/ProcurementDetailPage"));
export const ProcurementGuidePage = lazyPage(() => import("@/pages/ProcurementGuidePage"));
export const InventoryRequestCreatePage = lazyPage(() => import("@/pages/InventoryRequestCreatePage"));
export const InventoryRequestDetailPage = lazyPage(() => import("@/pages/InventoryRequestDetailPage"));

// ─── Products & suppliers ────────────────────────────────────────────────────
export const Products = lazyPage(() => import("@/pages/Products"));
export const ProductDetail = lazyPage(() => import("@/pages/ProductDetail"));
export const DeliveryOrders = lazyPage(() => import("@/pages/DeliveryOrders"));
export const Suppliers = lazyPage(() => import("@/pages/Suppliers"));

// ─── Admin ───────────────────────────────────────────────────────────────────
export const AdminSettings = lazyPage(() => import("@/pages/AdminSettings"));
export const AdminChangelog = lazyPage(() => import("@/pages/AdminChangelog"));
export const AdminUsers = lazyPage(() => import("@/pages/AdminUsers"));
export const AdminNotifications = lazyPage(() => import("@/pages/AdminNotifications"));
export const AdminNotificationLogs = lazyPage(() => import("@/pages/AdminNotificationLogs"));
export const AdminCustomerCommunicationLogs = lazyPage(
  () => import("@/pages/AdminCustomerCommunicationLogs"),
);
export const AdminDuplicateProducts = lazyPage(() => import("@/pages/AdminDuplicateProducts"));
export const AdminSalesDisclaimers = lazyPage(() => import("@/pages/AdminSalesDisclaimers"));
export const AdminProposalIntroPage = lazyPage(() => import("@/pages/AdminProposalIntroPage"));
export const AdminProposalIntroPreviewPage = lazyPage(
  () => import("@/pages/AdminProposalIntroPreviewPage"),
);
export const AdminAnalytics = lazyPage(() => import("@/pages/AdminAnalytics"));
export const RoServicingAnalytics = lazyPage(() => import("@/pages/RoServicingAnalytics"));
export const SvrAnalytics = lazyPage(() => import("@/pages/SvrAnalytics"));
export const AdminIssues = lazyPage(() => import("@/pages/AdminIssues"));
export const AdminCleoOperationsDesk = lazyPage(() => import("@/pages/AdminCleoOperationsDesk"));
export const AdminCleoMismatches = lazyPage(() => import("@/pages/AdminCleoMismatches"));
export const AdminCleoUnknownSignals = lazyPage(() => import("@/pages/AdminCleoUnknownSignals"));
export const AdminMcpConnections = lazyPage(() => import("@/pages/AdminMcpConnections"));
export const AdminCoachingPlaybook = lazyPage(() => import("@/pages/AdminCoachingPlaybook"));
export const AdminCustomersPage = lazyPage(() => import("@/pages/AdminCustomersPage"));
export const AdminActivityPage = lazyPage(() => import("@/pages/AdminActivityPage"));
export const AdminDigitalCardCompanyPage = lazyPage(
  () => import("@/pages/AdminDigitalCardCompanyPage"),
);
export const KaleidescapeDashboardPage = lazyPage(() => import("@/pages/KaleidescapeDashboardPage"));
export const ClubBookingsPage = lazyPage(() => import("@/pages/ClubBookingsPage"));
export const IntegrationTest = lazyPage(() => import("@/pages/IntegrationTest"));
export const AdminArticlesPage = lazyPage(() => import("@/pages/AdminArticlesPage"));
export const AdminArticleEditorPage = lazyPage(() => import("@/pages/AdminArticleEditorPage"));

// ─── Finance ─────────────────────────────────────────────────────────────────
export const PICDashboard = lazyPage(() => import("@/pages/PICDashboard"));
export const FinanceDashboard = lazyPage(() => import("@/pages/FinanceDashboard"));
export const FinanceTasks = lazyPage(() => import("@/pages/FinanceTasks"));
export const FinanceRevenue = lazyPage(() => import("@/pages/FinanceRevenue"));
export const FinanceReconciliation = lazyPage(() => import("@/pages/FinanceReconciliation"));
export const RevenueCalendar = lazyPage(() => import("@/pages/RevenueCalendar"));
export const FinanceInvoices = lazyPage(() => import("@/pages/FinanceInvoices"));
export const FinanceLegacyInvoiceImport = lazyPage(() => import("@/pages/FinanceLegacyInvoiceImport"));
export const ProposalsAwaitingInvoice = lazyPage(() => import("@/pages/ProposalsAwaitingInvoice"));
export const RevenueSchedule = lazyPage(() => import("@/pages/RevenueSchedule"));

// ─── Public / token pages ────────────────────────────────────────────────────
export const InvoicePage = lazyPage(() => import("@/pages/InvoicePage"));
export const ROInvoicePage = lazyPage(() => import("@/pages/ROInvoicePage"));
export const DealInvoicePage = lazyPage(() => import("@/pages/DealInvoicePage"));
export const PortalInvoicePage = lazyPage(() => import("@/pages/PortalInvoicePage"));
export const PortalInvoiceProposalPage = lazyPage(() => import("@/pages/PortalInvoiceProposalPage"));
export const RODeliveryPage = lazyPage(() => import("@/pages/RODeliveryPage"));
export const ProposalApprovalSuccessPage = lazyPage(() => import("@/pages/ProposalApprovalSuccessPage"));
export const ProposalPublicPage = lazyPage(() => import("@/pages/ProposalPublicPage"));
export const SecureProposalPublicPage = lazyPage(() => import("@/pages/SecureProposalPublicPage"));
export const ProposalLinkBUnavailablePage = lazyPage(
  () => import("@/pages/ProposalLinkBUnavailablePage"),
);
export const ManualApprovedProposalWrapperPage = lazyPage(
  () => import("@/pages/ManualApprovedProposalWrapperPage"),
);
export const ProposalWrapperPage = lazyPage(() => import("@/pages/ProposalWrapperPage"));
export const ProjectProposalPublicPage = lazyPage(() => import("@/pages/ProjectProposalPublicPage"));
export const ProjectProposalStaffPreviewPage = lazyPage(
  () => import("@/pages/ProjectProposalStaffPreviewPage"),
);
export const ProjectSharePublicPage = lazyPage(() => import("@/pages/ProjectSharePublicPage"));
export const PublicDigitalCardPage = lazyPage(() => import("@/pages/PublicDigitalCardPage"));
export const RetailTermsPage = lazyPage(() => import("@/pages/RetailTermsPage"));
export const ArticlesIndexPage = lazyPage(() => import("@/pages/ArticlesIndexPage"));
export const ArticlePublicPage = lazyPage(() => import("@/pages/ArticlePublicPage"));

// ─── Digital card ────────────────────────────────────────────────────────────
export const MyDigitalCardPage = lazyPage(() => import("@/pages/MyDigitalCardPage"));
export const DigitalCardPreviewPage = lazyPage(() => import("@/pages/DigitalCardPreviewPage"));

// ─── Install projects ────────────────────────────────────────────────────────
export const ProjectsListPage = lazyPage(() => import("@/pages/ProjectsListPage"));
export const ProjectDetailPage = lazyPage(() => import("@/pages/ProjectDetailPage"));
export const ProjectMarkupPage = lazyPage(() => import("@/pages/ProjectMarkupPage"));

// ─── Sales ───────────────────────────────────────────────────────────────────
export const SalesDashboard = lazyPage(() => import("@/pages/SalesDashboard"));
export const SalesInsightsPage = lazyPage(() => import("@/pages/SalesInsightsPage"));
export const SalesModulePlaceholderPage = lazyPage(() => import("@/pages/SalesModulePlaceholderPage"));
export const SalesProjectsPage = lazyPage(() => import("@/pages/SalesProjectsPage"));
export const SalesProjectCardPage = lazyPage(() => import("@/pages/SalesProjectCardPage"));
export const CleoProjectProposalBetaPage = lazyPage(() => import("@/pages/CleoProjectProposalBetaPage"));
export const SalesCustomerLogPage = lazyPage(() => import("@/pages/SalesCustomerLogPage"));
export const SalesAppointmentsPage = lazyPage(() => import("@/pages/SalesAppointmentsPage"));
export const SalesCataloguePage = lazyPage(() => import("@/pages/SalesCataloguePage"));
export const ProjectCatalogPage = lazyPage(() => import("@/pages/ProjectCatalogPage"));
export const SalesSettings = lazyPage(() => import("@/pages/SalesSettings"));
export const MyProposals = lazyPage(() => import("@/pages/MyProposals"));
export const ManualUploadedProposalDetailPage = lazyPage(
  () => import("@/pages/ManualUploadedProposalDetailPage"),
);
export const ReviseProposalPage = lazyPage(() => import("@/pages/ReviseProposalPage"));
export const VariationOrderWorkspacePage = lazyPage(() => import("@/pages/VariationOrderWorkspacePage"));
export const VariationOrderPublicPage = lazyPage(() => import("@/pages/VariationOrderPublicPage"));
export const VariationOrderStaffPreviewPage = lazyPage(() => import("@/pages/VariationOrderStaffPreviewPage"));
export const DtoolsProposalIntegrityPage = lazyPage(() => import("@/pages/DtoolsProposalIntegrityPage"));
export const SalesDealOverviewPage = lazyPage(() => import("@/pages/SalesDealOverviewPage"));
export const ProjectBomPreviewPage = lazyPage(() => import("@/pages/ProjectBomPreviewPage"));
export const SalesDailyBriefingPage = lazyPage(() => import("@/pages/SalesDailyBriefingPage"));
export const FollowUpStatusPage = lazyPage(() => import("@/pages/FollowUpStatusPage"));
export const SalesProposalIdEntryPage = lazyPage(() => import("@/pages/SalesProposalIdEntryPage"));
export const TimeMachinePage = lazyPage(() => import("@/pages/TimeMachinePage"));

// ─── D-Tools & sandboxes ─────────────────────────────────────────────────────
export const SalesSandboxPage = lazyPage(() => import("@/pages/SalesSandboxPage"));
export const DtoolsParserSandboxPage = lazyPage(() => import("@/pages/DtoolsParserSandboxPage"));
export const DtoolsJsonUploadSandboxPage = lazyPage(() => import("@/pages/DtoolsJsonUploadSandboxPage"));
export const DtoolsJsonSetupSandboxPage = lazyPage(() => import("@/pages/DtoolsJsonSetupSandboxPage"));
export const DtoolsJsonReviewSandboxPage = lazyPage(() => import("@/pages/DtoolsJsonReviewSandboxPage"));
export const ProposalIntelligenceSandboxPage = lazyPage(
  () => import("@/pages/ProposalIntelligenceSandboxPage"),
);
export const SalesInsightsSandboxPage = lazyPage(() => import("@/pages/SalesInsightsSandboxPage"));
export const ProjectMarkupSandboxPage = lazyPage(() => import("@/pages/ProjectMarkupSandboxPage"));
export const ProjectCatalogueSandboxPage = lazyPage(() => import("@/pages/ProjectCatalogueSandboxPage"));
export const HrsRackConfiguratorPage = lazyPage(() => import("@/pages/HrsRackConfiguratorPage"));

// ─── Clarity Website (future www.claritygroup.com.sg) ────────────────────────
export const ClarityWebsiteHomePage = lazyPage(() => import("@/pages/ClarityWebsiteHomePage"));
export const ClarityWebsiteAboutPage = lazyPage(() => import("@/pages/ClarityWebsiteAboutPage"));
export const ClarityWebsiteHogrPage = lazyPage(() => import("@/pages/ClarityWebsiteHogrPage"));
export const ClarityWebsiteHogrChapterPage = lazyPage(() => import("@/pages/ClarityWebsiteHogrChapterPage"));
export const ClarityWebsiteBuildMyHomePage = lazyPage(() => import("@/pages/ClarityWebsiteBuildMyHomePage"));
export const ClarityWebsiteSuperlativePage = lazyPage(() => import("@/pages/ClarityWebsiteSuperlativePage"));
export const ClarityWebsiteSuperlativeBrandPage = lazyPage(() => import("@/pages/ClarityWebsiteSuperlativeBrandPage"));
export const ClarityWebsiteSuperlativeProductPage = lazyPage(() => import("@/pages/ClarityWebsiteSuperlativeProductPage"));
export const ClarityWebsiteExperiencePage = lazyPage(
  () => import("@/pages/ClarityWebsiteExperiencePage"),
);
